import React from 'react'
import { useFormContext } from 'react-hook-form'

import {
  Button,
  Col,
  Grid,
  Input,
  InputMask,
  Picker,
  RadioGroup,
  Row,
  Span
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { IFilterConvention } from 'services/NGT/Convention'
import { SPACING } from 'utils'

interface IFilterConventionsProps {
  handleSearchConvention: () => void
}

export const FilterConventions: React.FC<IFilterConventionsProps> = ({
  handleSearchConvention,
}) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
  } = useFormContext<IFilterConvention>()

  const handleClearFilters = () => {
    reset()
    handleSearchConvention()
  }

  const documento = watch('cnpjFornecedor')

  return (
    <>
      <Grid
        gridCols="1fr 1fr 2.5fr 2fr 1fr 0.5fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing15} 0`}
      >
        <InputMask
          label="Contrato"
          placeholder="Nº"
          formValue="cdContrato"
          control={control}
          errors={errors}
        />
        <Input
          label="CPF/CNPJ/Cód.Fornecedor"
          placeholder="Nº"
          formValue="cnpjFornecedor"
          control={control}
          errors={errors}
          mask={
            documento && documento.length > 9 
                ? ['###.###.###-##', '##.###.###/####-##']
                : ['#########']
          }
          maxLength={18}
        />
        <InputMask
          label="Fornecedor"
          placeholder="Nome Completo"
          formValue="nmFornecedor"
          control={control}
          errors={errors}
        />
        <InputMask
          label="Sindicato / Confederação"
          placeholder="Nome Sindicato"
          formValue="nmSindicato"
          control={control}
          errors={errors}
        />
        <InputMask
          label="CNPJ Sindicato"
          placeholder="CNPJ"
          masks="cnpj"
          formValue="cnpjSindicato"
          control={control}
          errors={errors}
        />
      </Grid>
      <Grid
        gridCols="1fr 1fr 2fr 4fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing15} 0`}
      >
        <Picker
          control={control}
          errors={errors}
          formValue="dtvigenciaInicio"

          label="Início Vigência"
          maxDate={watch('dtvigenciaFim') || null}
        />
        <Picker
          control={control}
          errors={errors}
          formValue="dtvigenciaFim"
          label="Fim Vigência"
          minDate={watch('dtvigenciaInicio') || null}
        />
        <Col marginLeft={SPACING.spacing15}>
          <Span text="Vencido" />
          <RadioGroup
            control={control}
            errors={errors}
            row
            formValue="flVencido"
            listOptions={[
              { label: 'Sim', value: true },
              { label: 'Não', value: false },
              { label: 'Todos', value: 'Todos' }
            ]}
          />
        </Col>
        <Row justifyContent="flex-end">
          <Button
            text="LIMPAR"
            marginTop={SPACING.spacing15}
            variantButton="text"
            onClick={handleClearFilters}
          />
          <Button
            text="PESQUISAR"
            marginTop={SPACING.spacing15}
            endIcon={<MagnifyingGlassIcon />}
            marginLeft={SPACING.spacing20}
            onClick={handleSubmit(handleSearchConvention)}
          />
        </Row>
      </Grid>
    </>
  )
}
